import { RawGetPaymentMethodResponseSchema } from '@entities/payment-methods/model'
import { podoFetcher } from '@server/infrastructure/external-apis/podo/client'
import { rpc } from '@server/infrastructure/rpc'
import type { GetPaymentMethodsRes } from '@server/schemas'
import { queryOptions } from '@tanstack/react-query'

export const paymentMethodsEntityQueries = {
  all: ['payment-methods'],
  // queryKeys
  getRegisteredPaymentMethodsQueryKey: (requestDto: RequestQueryOptions) => [
    ...paymentMethodsEntityQueries.all,
    'getRegisteredPaymentMethods',
    requestDto,
  ],
  getPaymentMethodQueryKey: (requestDto: RequestQueryOptions) => [
    ...paymentMethodsEntityQueries.all,
    'getPaymentMethod',
    requestDto,
  ],

  // queryOptions
  getRegisteredPaymentMethods: (requestDto: RequestQueryOptions) =>
    queryOptions({
      queryKey: paymentMethodsEntityQueries.getRegisteredPaymentMethodsQueryKey(requestDto),
      queryFn: async (): Promise<GetPaymentMethodsRes | null> => {
        // 등록 결제수단은 마이포도의 부가 정보다. 미등록(404 CARD_NOT_FOUND)은 정상 상태이고,
        // 조회 실패도 마이포도 페이지 전체를 죽여선 안 된다. 이 쿼리는 prefetch 후 dehydrate 되는데,
        // queryFn 이 throw 하면 에러 상태가 캐시를 오염시켜 페이지 렌더가 전파 실패(500)한다.
        // 따라서 어떤 경우에도 throw 하지 않고 "결제수단 없음"(null) 으로 폴백한다.
        try {
          const response = await rpc.api.v1['payment-methods'].registered.$get(
            {},
            { headers: { Authorization: `Bearer ${requestDto.bearerToken}` } },
          )

          if (!response.ok) {
            return null
          }

          return (await response.json()) as GetPaymentMethodsRes
        } catch (error) {
          console.warn('[payment-methods] 등록 결제수단 조회 실패 → 결제수단 없음으로 폴백', error)
          return null
        }
      },
    }),
  getPaymentMethod: (requestDto: RequestQueryOptions) =>
    queryOptions({
      queryKey: paymentMethodsEntityQueries.getPaymentMethodQueryKey(requestDto),
      queryFn: async () =>
        await podoFetcher<RawGetPaymentMethodResponseSchema>({
          url: '/api/v1/card/list',
          method: 'GET',
          header: {
            Authorization: `Bearer ${requestDto.bearerToken}`,
          },
        }).then((res) => res.data),
    }),
}
